module.exports = __webpack_public_path__ + "static/media/passbook.008a7d11.svg";